/**
 * Folds nested changed fields into their parent so the summary stays short.
 * The API reports engine field changes as `fields` plus one `fields.<name>`
 * per engine field, which reads as `fields (amount_due, invoice_id)`.
 */
export const formatChangedFields = (fields: string[]): string[] => {
  const childrenByParent = new Map<string, string[]>();

  fields.forEach(field => {
    const [parent = field, ...rest] = field.split('.');
    const children = childrenByParent.get(parent) ?? [];
    childrenByParent.set(
      parent,
      rest.length ? [...children, rest.join('.')] : children
    );
  });

  return Array.from(childrenByParent, ([parent, children]) =>
    children.length ? `${parent} (${children.join(', ')})` : parent
  );
};
